import Emitter from "es6-event-emitter";
import { REACHED_REDIRECT_LIMIT } from "./../../common/analytics/analyticsevents";
// this class will implement al UI necessary to authenticate users
// and authorize downloads.
import { PAYWALL_REDIRECTION } from "./../../common/utilities/redirectorKeys";
import CookieManager from "./../utilities/cookiemanager";
import {
  createRedirectionUrl,
  isParameterInUrl,
  sendMessageIfBackButtonEnabled,
} from "./../utilities/utils";

export default class DownloadComponent extends Emitter {
  _authenticatorAuthorisationController = null;
  paywall = null;

  constructor(
    authenticatorAuthorisationController,
    paywall,
    options,
    APIManager,
    appState,
    errorPopup = null
  ) {
    // paywallIframeBannerSource    forgotPasswordLink
    super();
    this._authenticatorAuthorisationController =
      authenticatorAuthorisationController;
    this.paywall = paywall;
    this.errorPopup = errorPopup;
    this.options = options;
    this.APIManager = APIManager;
    this._appState = appState;
  }

  onAuthorizeSucces = (publicationData) => {
    this.removeEventListeners();
    this.trigger("downloadComponent:succes", publicationData);
  };

  onClose = () => {
    this.removeEventListeners();
    this.trigger("downloadComponent:close");
  };

  onErrorPopupClosed = (publicationData = null, err = null) => {
    this.removeEventListeners(true);
    if (err.data && err.data.errorType == "authorization") {
      if (isParameterInUrl(this.options.showBackButtonParam)) {
        sendMessageIfBackButtonEnabled();
      } else if (this.options.homeRedirectionLink) {
        window.top.location.href = this.options.homeRedirectionLink;
      } else {
        this.trigger("downloadComponent:close");
      }
    } else {
      this._authenticatorAuthorisationController.logOut().catch(() => {
        //if LOGOUT_REDIRECTION failed show paywall
        this.APIManager.getUserProfileValue(PAYWALL_REDIRECTION)
          .then((result) => {
            if (
              result &&
              result[0] &&
              result[0].Value &&
              result[0].Value.length > 0
            ) {
              window.top.location.href = createRedirectionUrl(
                result[0].Value,
                this._authenticatorAuthorisationController,
                this.options,
                publicationData
              );
            }
          })
          .catch(() => {
            this.paywall.show(publicationData, false);
          });
      });
    }
  };

  validateDownload(publicationData, confirmdownload, showPaywall = true) {
    //TODO: confirmdownload
    this._authenticatorAuthorisationController
      .authorize(publicationData, confirmdownload)
      .then(() => {
        this.trigger("downloadComponent:succes", publicationData);
      })
      .catch((err) => {
        if (showPaywall) {
          if (err) {
            //authorization errors are displayed on the error popup
            if (err.data && err.data.errorType == "authorization") {
              this.errorPopup.show(err);
              this.errorPopup.on("errorPopup:close", () => {
                this.onErrorPopupClosed(publicationData, err);
              });
              return;
            }
            if (this.options.paywallRedirectionUrl) {
              //for customers with custom paywall always display errors on the error popup
              this.errorPopup.show(err);
              this.errorPopup.on("errorPopup:close", () => {
                this.onErrorPopupClosed(publicationData, err);
              });
              return;
            }
          }
          this.paywall.showError(err);
          this.paywall.on("paywall:close", this.onClose);
          this.paywall.on("paywall:authorizeSucces", this.onAuthorizeSucces);
          if (this.options.paywallRedirectionUrl) {
            const number = CookieManager.getNumberOfRedirects();
            if (number >= this.options.paywallRedirectionNumber) {
              this._appState.triggerEvent(REACHED_REDIRECT_LIMIT);
              this.paywall.show(publicationData, false);
            } else {
              this.APIManager.getUserProfileValue(PAYWALL_REDIRECTION)
                .then((result) => {
                  if (result && result[0] && result[0].Value) {
                    CookieManager.setNumberOfRedirects(
                      number + 1,
                      this.options.paywallRedirectionTimeReset
                    );

                    window.top.location.href = createRedirectionUrl(
                      result[0].Value,
                      this._authenticatorAuthorisationController,
                      this.options,
                      publicationData
                    );
                  } else {
                    this.paywall.show(publicationData, false);
                  }
                })
                .catch(() => {
                  this.paywall.show(publicationData, false);
                });
            }
          } else {
            this.paywall.show(publicationData, false);
          }
        } else {
          this.trigger("downloadComponent:fail", publicationData);
        }
      });
  }

  removeEventListeners(isErrorPopupListners = false) {
    if (isErrorPopupListners) {
      this.errorPopup.off("errorPopup:close", () => {
        this.onErrorPopupClosed();
      });
    } else {
      this.paywall.off("paywall:close", this.onClose);
      this.paywall.off("paywall:authorizeSucces", this.onAuthorizeSucces);
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/downloadcomponent.js